import { REGISTER_ENDPOINT, UPDATE_CONNECTION } from "../actions";
import initialState from "./initialState";
import { find, uniqueId, findKey } from "lodash";
import Log from "../utils/Log";
export default function connections() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.connections, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case REGISTER_ENDPOINT:
            {
                if (!state[action.key]) {
                    var newConnection = createNewEndpoint(action.endpoint, action.key, state);
                    if (newConnection) {
                        state[action.key] = newConnection;
                    } else {
                        Log.warn("New Endpoint with key" + action.key + "could not be created. Endpoint already exists.");
                    }
                    return state;
                } else {
                    Log.warn("An endpoint with that key ( " + action.key + " ) already exists, key must be unique.");
                }
                return state;
            }
        case UPDATE_CONNECTION:
            {
                var con = find(state, {
                    endpoint: action.endpoint
                }) || createNewEndpoint(action.endpoint, uniqueId("con_"), state);
                if (con) {
                    con.status = action.status;
                    con.reason = action.reason || "";
                    var key = findKey(state, con);
                    if (key) {
                        state[key] = con;
                    }
                    state.diff = con;
                }
                return state;
            }
        default:
            return state;
    }
}
function createNewEndpoint(endpoint, key, connections) {
    var newEndpoint = endpoint.match(/(http[s]?|ftp)?:?\/?\/?(.+)/)[2];
    if (!find(connections, {
        endpoint: newEndpoint
    }) && newEndpoint) {
        return {
            endpoint: newEndpoint,
            key: key,
            status: null,
            reason: ""
        };
    } else {
        Log.warn("Endpoint ( " + newEndpoint + " ) already registered.");
    }
    return null;
}
